import React, { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'
import CreationToolOutputType from '../../../types/output-type'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Toggle from '../../toggle'
import { Instructions } from '../field-instructions'
import Title from '../field-title'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock)`
    grid-column: span 4;
`

const VisiblityToggle = styled(Toggle)`
    width: 200px;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadPrivacyField = ({ className, field }: Props) => {
    const { tool, outputType } = useContext(CreationToolsContext)
    const { username, isPublic, setIsPublic } = useContext(CreationToolUploadContext)
    const outputTypeTitle = CreationToolOutputType.title(outputType)
    const learnMoreUrl = CreationToolUploadField.learnMoreUrl(field)
    const privateInstructions = `Only you can see this.`
    let publicInstructions = `Anyone can see this.`

    // only display integration info if using sticker maker
    if (username && outputType === CreationToolOutputType.Sticker && tool === CreationTool.GifMaker) {
        publicInstructions += ` Searching @${username} lets you find & use this ${outputTypeTitle} in select integrations.`
    }

    return (
        <Container className={className}>
            <Title field={field} />
            <VisiblityToggle onLabel="Public" offLabel="Private" isOn={isPublic} onToggle={setIsPublic} />
            <Instructions>
                {isPublic ? publicInstructions : privateInstructions}{' '}
                {learnMoreUrl && (
                    <a href={learnMoreUrl} target="_blank" rel="noopener noreferrer">
                        Learn More
                    </a>
                )}
            </Instructions>
        </Container>
    )
}

export default CreationUploadPrivacyField
